var api = require("!../../../../style-loader@1.3.0-aef31add4e607c5bff90/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader@5.2.7-01420203bd3cf31de934/node_modules/css-loader/dist/cjs.js!./slick-theme.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};